import { useDimensions } from "./Util.jsx";
import TitleBar from "./TitleBar/TitleBar.jsx";
import Footer from "./Footer/Footer.jsx";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage/LandingPage.jsx";
import Profile from "./Profile/Profile.jsx";
import Notifications from "./Notifications/Notifications.jsx";
import Messages from "./Messages/Messages.jsx";
import Alternates from "./Alternates/Alternates.jsx";
import PopupRenderer from "./PopupRenderer/PopupRenderer.jsx";
import ComingSoon from "./LandingPage/AddictionsContainer/AddictionBody/ComingSoon.jsx";


function App() {

  const { w, h } = useDimensions();

  const fullScreen = {
    width: 100 * w,
    height: 100 * h
  }

  const body = {
    width: 98 * w,
    height: 91 * h,
    marginInline: w,
    boxSizing: "border-box"
  }

  const actsData = [
    {id:'read-and-let-read',image:'read-and-let-read.png',text:'Read And Let Read',type:'time',value:'15'},
    {id:'penny-stocks',image:'penny-stocks.png',text:'Penny Stocks',type:'money',value:'5'},
    {id:'read-and-review',image:'read-and-review.png',text:'Read And Review',type:'time',value:'25'},
    {id:'gold-bonds',image:'gold-bonds.png',text:'Gold Bonds',type:'money',value:'25'},
    {id:'crypto-currencies',image:'crypto-currency.png',text:'Crypto Currencies',type:'money',value:'10'},
    {id:'random-recipie',image:'random-recepie.png',text:'Random Recipie',type:'time',value:'40'},
    {id:'mutual-funds',image:'mutual-funds.png',text:'Mutual Funds',type:'money',value:'15'},
    {id:'make-new-friend',image:'make-new-friend.png',text:'Make A New Friend',type:'time',value:'10'},
    {id:'fixed-deposit',image:'fixed-deposit.png',text:'Fixed Deposit',type:'money',value:'50'},
    {id:'sport-buddy',image:'sport-buddy.png',text:'Sport Buddy',type:'time',value:'60'},
    {id:'alternate-gambling',image:'alternate-gambling.png',text:'Alternate Gambling',type:'money',value:'5'},
    {id:'express-thoughts',image:'express-thoughts.png',text:'Express Thoughts',type:'time',value:'10'},
    {id:'knowledge-bytes',image:'knowledge-bytes.png',text:'Knowledge Bytes',type:'time',value:'5'},
    {id:'coder-steps',image:'coder-steps.png',text:'Coder Steps',type:'time',value:'10'},
];

  return (
    <div id="app" style={fullScreen}>
      <Router>
        <TitleBar></TitleBar>
        <div id="body" style={body}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/alternates" element={<Alternates actsData={actsData}/>} />
            <Route path="/popup" element={<PopupRenderer />} />
            <Route path="/comingsoon" element={<ComingSoon />} />
          </Routes>
        </div>
        <Footer></Footer>
      </Router>
    </div >
  );
}

export default App;
